import { z } from 'zod';

import {
  zodContractActionMetadataSchema,
  zodContractActionSchema,
  zodContractSchema,
} from '../validations';

// Re-export shared validations used by this hook
export { zodContractActionSchema };

// Execute contract action payload schema (POST /contracts/{id}/action)
export const zodExecuteContractActionPayloadSchema = z.object({
  action: zodContractActionSchema,
  notes: z.string().nullish(),
});

// Execute contract action response schema (includes contract and available actions)
export const zodExecuteContractActionResponseSchema = z.object({
  actionsMetadata: z.array(zodContractActionMetadataSchema),
  availableActions: z.array(zodContractActionSchema),
  contract: zodContractSchema,
});
